module.exports = __webpack_public_path__ + "static/img/logo_17@2x.c2d6d13d.jpeg";